import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import styles from "./../../assets/scss/custom.module.scss";
import { pagination } from "../../locales/en";
import "./../../assets/scss/common.scss";
import { PAGE_SIZE_OPTIONS } from "../../utils/constants/appConstants";

const Pagination = ({
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageCount,
  pageOptions,
  setPageSize,
  pageSize,
  showButtons,
  onPaginationChange,
  dataLength,
  pageSizeOptions = PAGE_SIZE_OPTIONS
}) => {
  const [inputValue, setInputValue] = useState(pageIndex + 1);

  useEffect(() => {
    setInputValue(pageIndex + 1);
  }, [pageIndex]);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    gotoPage(0);
    onPaginationChange && onPaginationChange(true);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e) => {
    if (["-", "e", "E", "+", "."].includes(e.key)) {
      e.preventDefault();
    }

    if (e.key === "Enter") {
      if (pageOptions.length === 0) return;

      let pageNumber = inputValue ? Number(inputValue) : 1;

      if (pageNumber < 1) {
        pageNumber = 1;
      } else if (pageNumber > pageOptions.length) {
        pageNumber = pageOptions.length;
      }

      setInputValue(pageNumber);
      gotoPage(pageNumber - 1);
      onPaginationChange && onPaginationChange(true);
    }
  };

  return (
    <div className={`${styles.pagiNationBar} mainPagination`}>
      {showButtons ? (
        <>
          <button
            className="px-0"
            onClick={() => {
              gotoPage(0);
              onPaginationChange && onPaginationChange(true);
            }}
            disabled={!canPreviousPage}
          >
            <FaAngleDoubleLeft />
          </button>
          <button
            onClick={() => {
              previousPage();
              onPaginationChange && onPaginationChange(true);
            }}
            disabled={!canPreviousPage}
          >
            {pagination?.previous}
          </button>
          <span>
            {`${pagination?.page}  `}
            <strong>
              {pageOptions.length > 0 ? pageIndex + 1 : 0} of{" "}
              {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => {
              nextPage();
              onPaginationChange && onPaginationChange(true);
            }}
            disabled={!canNextPage}
          >
            {pagination?.next}
          </button>
          <button
            className="ps-0"
            onClick={() => {
              if (pageCount > 0) {
                gotoPage(pageCount - 1);
                onPaginationChange && onPaginationChange(true);
              }
            }}
            disabled={!canNextPage || pageCount === 0}
          >
            <FaAngleDoubleRight />
          </button>
        </>
      ) : (
        <>
          <span className="goToPage">
            {`${pagination?.gotoPage} `}
            <input
              className="text-center width-50"
              type="number"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              disabled={
                pageCount === 1 &&
                typeof dataLength === "number" &&
                dataLength < 10
              }
              min={1}
              max={pageOptions.length}
            />
          </span>

          <span className="showArea">
            {pagination?.show}
            <select
              className={styles.selectShowStatus}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(Number(e.target.value))}
              disabled={
                pageCount === 1 &&
                typeof dataLength === "number" &&
                dataLength < 10
              }
            >
              {pageSizeOptions.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </span>
        </>
      )}
    </div>
  );
};
Pagination.propTypes = {
  gotoPage: PropTypes.any,
  previousPage: PropTypes.any,
  nextPage: PropTypes.any,
  canPreviousPage: PropTypes.any,
  canNextPage: PropTypes.any,
  pageIndex: PropTypes.any,
  pageCount: PropTypes.any,
  pageOptions: PropTypes.any,
  setPageSize: PropTypes.any,
  pageSize: PropTypes.any,
  showButtons: PropTypes.bool,
  onPaginationChange: PropTypes.func,
  dataLength: PropTypes.number,
  pageSizeOptions: PropTypes.array
};

export default Pagination;
